<template>
  <div class="postcode-input position-relative">
    <b-form-input
      :id="inputId"
      :value="value"
      :state="state"
      type="text"
      maxlength="7"
      autocomplete="off"
      :placeholder="placeholder"
      @input="onInput"
      @blur="onBlur"
    />
    <ul v-if="suggestions.length" class="postcode-suggestions list-unstyled">
      <li v-for="s in suggestions" :key="s" @mousedown.prevent="select(s)">{{ s }}</li>
    </ul>
  </div>
</template>

<script>
import { formatPostcodeInput, suggestPostcodes } from '../support/postcode';

export default {
  name: 'PostcodeInput',
  props: {
    value: { type: String, default: '' },
    country: { type: String, required: true },
    state: { default: null },
    inputId: { type: String, default: 'postcode' },
  },
  data() {
    return { suggestions: [] };
  },
  computed: {
    placeholder() {
      return this.country === 'CA' ? 'i.e. M5V 3L9' : 'i.e. 2000';
    },
  },
  methods: {
    onInput(val) {
      const formatted = formatPostcodeInput(val, this.country);
      this.$emit('input', formatted);
      suggestPostcodes(formatted, this.country).then(s => {
        this.suggestions = s;
      });
    },
    select(s) {
      this.$emit('input', formatPostcodeInput(s, this.country));
      this.suggestions = [];
    },
    onBlur() {
      setTimeout(() => {
        this.suggestions = [];
      }, 200);
    },
  },
};
</script>

<style scoped>
.postcode-suggestions {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 1000;
  margin: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  max-height: 188px;
  overflow-y: auto;
}
.postcode-suggestions li {
  padding: 10px 14px;
  font-size: 14px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}
.postcode-suggestions li:last-child {
  border-bottom: 0;
}
.postcode-suggestions li:hover {
  background: #f5f7fa;
}
</style>
